// extracted by mini-css-extract-plugin
export default {"menu":"Apartments_menu__mVUCq","menuTitle":"Apartments_menuTitle__n9Zzy","menuItem":"Apartments_menuItem__i6z4x","link":"Apartments_link__2mBsX"};